// communicationReducer.js
import actions from './actions';

const initialState = {
    loading: false,
    error: null,
    message: null,
    buttonLoading: false,
    emails: {},
    totalData: null,
    show: false,
};

const communicationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.UPDATE_EMAIL_READ:
            return {
                ...state,
                loading: true,
            };
        case actions.UPDATE_EMAIL_READ_SUCCESS:
            return {
                ...state,
                loading: false,
                communicationResponses: [...state.communicationResponses, action.payload.message],
            };
        case actions.UPDATE_EMAIL_READ_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
            case actions.GET_MAILS_DATA:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_MAILS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        emails: action.payload.data,
        totalData: action.payload.totalData,
      };
    case actions.GET_MAILS_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
        default:
            return state;
    }
};

export default communicationReducer;
